// Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React, { useEffect } from 'react'
import { object, string } from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { Field } from 'redux-form'
import { SelectFromState } from 'components/Form'
import { fetchAndAddAntennaSettings } from 'redux/modules/domain'

const Classification = ({ antennaClassifications, form }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    !antennaClassifications.size &&
    dispatch(fetchAndAddAntennaSettings())
  }, [])

  return (
    <Field
      className={'classification'}
      component={SelectFromState}
      emptyOptionLabel={'All'}
      id={`${form}-classification`}
      name={'classificationId'}
      selectLabel={'Classification'}
      targetSet={'antennaClassifications'} />
  )
}

Classification.propTypes = {
  antennaClassifications: object.isRequired,
  form: string.isRequired,
}

const mapStateToProps = ({ domain }) => ({
  antennaClassifications: domain.get('antennaClassifications'),
})

export default connect(
  mapStateToProps,
)(Classification)
